/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
import * as i0 from "./menu.component.scss.shim.ngstyle";
import * as i1 from "@angular/core";
import * as i2 from "../../../../../node_modules/primeng/panelmenu/primeng-panelmenu.ngfactory";
import * as i3 from "primeng/panelmenu";
import * as i4 from "./menu.component";
var styles_MenuComponent = [i0.styles];
var RenderType_MenuComponent = i1.ɵcrt({ encapsulation: 0, styles: styles_MenuComponent, data: {} });
export { RenderType_MenuComponent as RenderType_MenuComponent };
export function View_MenuComponent_0(_l) { return i1.ɵvid(2, [(_l()(), i1.ɵeld(0, 0, null, null, 1, "p-panelMenu", [], null, null, null, i2.View_PanelMenu_0, i2.RenderType_PanelMenu)), i1.ɵdid(1, 49152, null, 0, i3.PanelMenu, [i1.ChangeDetectorRef], { model: [0, "model"], multiple: [1, "multiple"] }, null)], function (_ck, _v) { var _co = _v.component; var currVal_0 = _co.menuItems; var currVal_1 = false; _ck(_v, 1, 0, currVal_0, currVal_1); }, null); }
export function View_MenuComponent_Host_0(_l) { return i1.ɵvid(0, [(_l()(), i1.ɵeld(0, 0, null, null, 1, "app-menu", [], null, null, null, View_MenuComponent_0, RenderType_MenuComponent)), i1.ɵdid(1, 49152, null, 0, i4.MenuComponent, [], null, null)], null, null); }
var MenuComponentNgFactory = i1.ɵccf("app-menu", i4.MenuComponent, View_MenuComponent_Host_0, { items: "items" }, {}, []);
export { MenuComponentNgFactory as MenuComponentNgFactory };
